<template lang="pug">
	#home
		nav-bar
		r-header
		our-services
		best-price
		why-choose-us
		what-they-say-about-us
		gallery
		find-us
		r-footer
</template>

<script>
import NavBar from '@/components/NavBar'
import RHeader from '@/components/RHeader'
import OurServices from '@/components/OurServices'
import BestPrice from '@/components/BestPrice'
import WhyChooseUs from '@/components/WhyChooseUs'
import WhatTheySayAboutUs from '@/components/WhatTheySayAboutUs'
import Gallery from '@/components/Gallery'
import FindUs from '@/components/FindUs'
import RFooter from '@/components/RFooter'

export default {
	components: {
		NavBar,
		RHeader,
		OurServices,
		BestPrice,
		WhyChooseUs,
		WhatTheySayAboutUs,
		Gallery,
		FindUs,
		RFooter
	},
	data: () => ({
		date: '',
	})
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#home
	float left
	width 100%
	height 100%
	min-height 100%
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue